import { useEffect, useState } from "react";
import { mediaUrl, useSiteContent } from "../../lib/siteContent";

export default function MyPartners() {
  const site = useSiteContent();
  const section = site.my_partners || {};
  const items = (section.items || []).filter((p) => p?.logo || p?.name);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    if (items.length < 2) return undefined;
    const t = setInterval(() => setIdx((p) => (p + 1) % items.length), 2800);
    return () => clearInterval(t);
  }, [items.length]);
  if (section.enabled === false || !items.length) return null;
  const visible = items.length <= 4
    ? items
    : [0, 1, 2, 3].map((off) => items[(idx + off) % items.length]);
  return (
    <section data-testid="my-partners" className="py-16 md:py-24 bg-[#faf8fc]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#f37721]" style={{ fontFamily: "Montserrat" }}>{section.eyebrow || "My Partners"}</span>
        <h2 className="text-3xl font-bold text-[#311b52] mt-3 mb-8" style={{ fontFamily: "Poppins" }}>{section.headline || "Trusted partners"}</h2>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {visible.map((p, i) => {
            const inner = (
              <div className="h-28 rounded-2xl bg-white border border-[#673c96]/10 flex flex-col items-center justify-center gap-2 px-4">
                {p.logo ? <img src={mediaUrl(p.logo)} alt={p.name || "Partner"} className="max-h-12 max-w-full object-contain" /> : null}
                {p.name ? <p className="text-xs font-semibold text-[#311b52] text-center">{p.name}</p> : null}
              </div>
            );
            return p.url ? (
              <a key={`${p.name || i}-${i}`} href={p.url} target="_blank" rel="noreferrer">{inner}</a>
            ) : <div key={`${p.name || i}-${i}`}>{inner}</div>;
          })}
        </div>
      </div>
    </section>
  );
}
